import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {withTranslation} from "react-i18next";
import {RootState} from "../../../../../reducers";
import PromotionInfoModalComponent from "../../../../components/Cart/components/PromotionInfoModalComponent";
import ScrollableTabs from "../../../../components/Common/ScrollableTabs";
import MenuPromotionItem from "./MenuPromotionItem";
import {getStoreConfig} from "../../../../services/Store/reducer";
import MenuPromotionCoupon from "./MenuPromotionCoupon";

interface OwnProps {
    promotions?: any[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuPromotionsComponent = ({promotions, config}: Props) => {
    const [promotionToShow, setPromotionToShow] = useState<any>();
    const isAdvertCodeBoxEnabled = config?.old_settings?.advert_code_box === "true";
    const anyPromotionVisible = isAdvertCodeBoxEnabled || (promotions && promotions.length > 0);

    if (!anyPromotionVisible) return null;

    return (
        <div className={"container promotions"}>
            <ScrollableTabs hideScrollbars={false} scrollStep={200}>
                {
                    isAdvertCodeBoxEnabled && (
                        <MenuPromotionCoupon singleItem={promotions?.length === 0}/>
                    )
                }
                {
                    promotions && promotions.map((promotion: any) => <MenuPromotionItem key={promotion.id}
                                                                                        singleItem={isAdvertCodeBoxEnabled ? false : promotions.length === 1}
                                                                                        promotion={promotion}
                                                                                        setPromotionToShow={setPromotionToShow}/>)
                }
            </ScrollableTabs>
            {promotionToShow && (
                <PromotionInfoModalComponent name={promotionToShow.name}
                                             promotionId={promotionToShow.id}
                                             onHide={() => setPromotionToShow(undefined)}/>
            )}
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuPromotionsComponent));